import type { GenerationFilters } from '@/pages/Settings/generation/filters/types';

/**
 * Hierarchical query keys for the generations domain. The factory exposes
 * "branch" helpers (`lists`, `counts`, `details`) so consumers can
 * invalidate a partial subtree without nuking unrelated caches.
 *
 * Examples:
 * - `generationKeys.lists(processId)` matches every page/filter combination.
 * - `generationKeys.counts(processId)` matches the count under any filter.
 * - `generationKeys.all(processId)` matches everything for a process.
 */
export const generationKeys = {
  all: (processId: string) => ['generations', processId] as const,
  lists: (processId: string) =>
    [...generationKeys.all(processId), 'list'] as const,
  list: (processId: string, params: { page: number; take: number; filters?: GenerationFilters }) =>
    [...generationKeys.lists(processId), params] as const,
  counts: (processId: string) =>
    [...generationKeys.all(processId), 'count'] as const,
  count: (processId: string, filters?: GenerationFilters) =>
    [...generationKeys.counts(processId), filters] as const,
  details: (processId: string) =>
    [...generationKeys.all(processId), 'detail'] as const,
  detail: (processId: string, generationId: string) =>
    [...generationKeys.details(processId), generationId] as const,
  logs: (processId: string, generationId: string) =>
    [...generationKeys.detail(processId, generationId), 'logs'] as const,
};
